import * as React from 'react';
import { dateParser } from '@common/dateParser';
import ReactDatePicker from 'react-datepicker';
import { Control, Errors } from 'react-redux-form';
import * as moment from 'moment-timezone';
import { SpinnerPage } from '@common/components/spinner/spinner-page.component';
import { getDefaultErrorMessages, hasDateValue } from '@common/validators';
export interface DateTimePickerComponentProperties {
  readonly dateValue: Date;
  readonly saveCallback?: (dateString: string) => void;
  readonly changeCallback?: (dateString: Date) => void;
  readonly buttonRef: (button: HTMLButtonElement) => void;
  readonly isLoading: boolean;
  readonly formString: string;
  readonly modelString: string;
  readonly label: string;
  readonly requiresValue: boolean;
  readonly maxDate?: moment.Moment;
  readonly minDate?: moment.Moment;
  readonly className: string;
  readonly disabled?: boolean;
}

export class DateTimePickerComponent extends React.Component<DateTimePickerComponentProperties> {
  handleSubmit = (formData: { resaleDate: moment.Moment }) => {
    if (this.props.saveCallback) {
      this.props.saveCallback(formData.resaleDate.utc(false).format('MM/DD/YYYY'));
    }
  };
  handleControlChange = (resaleDate: moment.Moment) => {
    // var dto = new Date().getTimezoneOffset();
    // var date = new Date(resaleDate.toDate().getTime() - dto * 60000);
    var date = resaleDate.toDate();
    if (this.props.changeCallback) {
      this.props.changeCallback(date);
    }
  };
  render() {
    if (this.props.isLoading) {
      return <SpinnerPage />;
    }
    if (true) {
      return (
        <div className={`form-control ${this.props.className}`}>
          <label htmlFor={`${this.props.formString}${this.props.modelString}`}>{this.props.label}</label>
          <Control
            model={`${this.props.modelString}`}
            validators={this.props.requiresValue ? { hasDateValue: hasDateValue } : {}}
            disabled={this.props.disabled}
            component={props => {
              let val;
              if (props.value && !moment.isMoment(props.value)) {
                val = dateParser.parse(props.value);
              } else {
                val = props.value;
              }
              return (
                <ReactDatePicker
                  disabled={this.props.disabled}
                  value={val || props.value ? dateParser.parse(props.value).format('MM/DD/YYYY') : ''}
                  selected={
                    val || props.value ? moment(dateParser.parse(props.value).format('MM/DD/YYYY'), 'MM/DD/YYYY') : null
                  }
                  minDate={this.props.minDate}
                  maxDate={this.props.maxDate}
                  onChange={(dateValue: moment.Moment) => {
                    props.onChange(dateValue);
                    this.handleControlChange(dateValue);
                    return dateValue.toString();
                  }}
                />
              );
            }}
          />
          <Errors
            className="error"
            model={this.props.modelString}
            show={{ touched: true, focus: false }}
            messages={{ ...getDefaultErrorMessages(), validDate: 'Invalid Date' }}
          />
          <div className="col-md-12">
            <div className="row end-xs">
              <button
                className="btn btn-hidden"
                type="submit"
                ref={this.props.buttonRef}
                disabled={this.props.isLoading}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/date-time-picker/date-time-picker.component.tsx